import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const items = [{
  id: 0,
  name: 'Churro espiral con chocolate y M&Ms',
  image: 'https://cdn.magicpatterns.com/uploads/drG4ovzY9Q4pegA384M7DP/IMG_1800.jpg',
  alt: 'Churro espiral artesano con chocolate y M&Ms',
  category: 'Estrella'
}, {
  id: 1,
  name: 'Crepe de chocolate con fresas',
  image: 'https://cdn.magicpatterns.com/uploads/nNfeL83K5ZUB4vhxjAePpy/Captura_de_pantalla_2026-05-15_a_las_17.00.49.png',
  alt: 'Crepe relleno y decorado con chocolate y fresas frescas',
  category: 'Dulce'
}, {
  id: 2,
  name: 'Batido de chocolate',
  image: 'https://cdn.magicpatterns.com/uploads/s36YfCQ2Cgaohfw5GXWvEw/Captura_de_pantalla_2026-05-15_a_las_17.01.08.png',
  alt: 'Batido de chocolate con nata montada y sirope',
  category: 'Bebida'
}, {
  id: 3,
  name: 'Tosta de lomo asado',
  image: 'https://cdn.magicpatterns.com/uploads/vQpb81hi1ET5r1SGvUR665/Captura_de_pantalla_2026-05-15_a_las_17.17.41.png',
  alt: 'Tosta de pan con láminas de lomo asado',
  category: 'Tostas'
}, {
  id: 4,
  name: 'Tosta de salmón ahumado',
  image: 'https://cdn.magicpatterns.com/uploads/kbXY3ZpBa4Tc438aUBHATq/IMG_1815.jpg',
  alt: 'Tosta de salmón ahumado con queso crema, lechuga y sésamo negro',
  category: 'Tostas'
}, {
  id: 5,
  name: 'Tosta de huevos con aguacate',
  image: 'https://cdn.magicpatterns.com/uploads/3o7c5ADnXrBrZQ6P478Mdg/IMG_1816.jpg',
  alt: 'Tosta con dos huevos sobre aguacate, lechuga y sésamo negro',
  category: 'Tostas'
}, {
  id: 6,
  name: 'Tortilla en pinchos con anchoas',
  image: 'https://cdn.magicpatterns.com/uploads/kMFsE5VnQj9EL1eED33rFJ/Captura_de_pantalla_2026-05-15_a_las_17.21.31.png',
  alt: 'Pinchos de tortilla española acompañados de ensalada de anchoas, aguacate y tomate',
  category: 'Para picar'
}, {
  id: 7,
  name: 'Gofre con chocolate',
  image: 'https://cdn.magicpatterns.com/uploads/eMzMcJtdjFNe2sm58rkgX5/IMG_1823.jpg',
  alt: 'Gofre artesano bañado en chocolate sobre plato gris',
  category: 'Dulce'
}, {
  id: 8,
  name: 'Crepe con helado y chocolate',
  image: 'https://cdn.magicpatterns.com/uploads/44ZP6vZT6KVGfwrxFCMbe2/IMG_1822.jpg',
  alt: 'Crepe con helado, nata montada y sirope de chocolate',
  category: 'Dulce'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function FeaturedItems() {
  return <section className="py-20 md:py-28 bg-white" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="text-center mb-16" data-id="element-65">
          <span className="text-cafe-accent text-sm tracking-[0.3em] uppercase font-medium" data-id="element-66">
            Carta destacada
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-cafe-primary mt-3 mb-4" data-id="element-67">
            Nuestras Especialidades
          </h2>
          <div className="w-24 h-px bg-cafe-accent mx-auto" data-id="element-68" />
          <p className="text-cafe-text/70 max-w-2xl mx-auto mt-6 text-lg" data-id="element-69">
            Churros, crepes, tostas y batidos elaborados al momento. Una
            selección para cualquier momento del día.
          </p>
        </div>
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-70">
          {items.map(item => <motion.article key={item.id} variants={itemVariants} className="group" data-id="element-71">
              <div className="relative overflow-hidden rounded-2xl aspect-[4/5] mb-5 shadow-soft bg-cafe-card" data-id="element-72">
                <img src={item.image} alt={item.alt} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-73" />
                <div className="absolute top-4 left-4" data-id="element-74">
                  <span className={`inline-flex items-center gap-1.5 text-xs tracking-wider uppercase font-medium px-3 py-1.5 rounded-full shadow-sm ${item.category === 'Estrella' ? 'bg-cafe-primary text-white' : 'bg-white/95 backdrop-blur-sm text-cafe-primary'}`} data-id="element-75">
                    {item.category === 'Estrella' && <Star size={10} className="fill-current" data-id="element-76" />}
                    {item.category}
                  </span>
                </div>
              </div>
              <h3 className="text-xl font-serif text-center text-cafe-primary leading-snug px-2" data-id="element-77">
                {item.name}
              </h3>
            </motion.article>)}
        </motion.div>
      </div>
    </section>;
}